import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Item = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/_jsx("option", {
    value: value,
    ref: ref,
    children: children
  });
});
Item.displayName = 'Item';
export default Item;
Item.propTypes = {
  children: PropTypes.string.isRequired,
  /**
   * The value of the option
   */
  value: PropTypes.string.isRequired
};